import React from "react";
import { check } from "../../resources/js/images";
import P from "../../shared/typography/P";

const SuccessMsg = ({ message = "success" }) => {
    return (
        <div className="flex flex-col p-4 gap-2 justify-center items-center">
            <img src={check} alt="check" className="w-6 h-6" />
            <P className="text-center font-medium">{message}</P>
        </div>
    );
};

export default SuccessMsg;
